export default __webpack_public_path__ + "static/media/cloth.09b4dfd6.jpg";